/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-curly-newline */
import React, {
  useEffect,
  useRef,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useRouteMatch, Link } from 'react-router-dom';

import {
  format,
  parseISO,
  isBefore,
  endOfToday,
  isAfter,
  addDays,
} from 'date-fns';

import { Container, Button, Row, Col, Table, Badge } from 'react-bootstrap';

import {
  FaCheckCircle,
  FaPlusCircle,
  FaUser,
  FaTrash,
  FaFile,
  FaGavel,
  FaAddressCard,
  FaHistory,
  FaCalendar,
  FaPhone,
  FaBan,
  FaRegCheckCircle,
  FaEdit,
  FaBarcode,
} from 'react-icons/fa';
import Modal from '../../components/Modal';

import api from '../../services/api';

import { useToast } from '../../hooks/toast';
import { useAuth } from '../../hooks/auth';
import { useClinica } from '../../hooks/clinica';

import Loading from '../../components/Loading';

import {
  Card,
  CardHeader,
  CardHeaderCenter,
  CardBody,
  ButtonAdd,
  Cartao,
} from './styles';

import {
  formataCPF,
  formataCNPJ,
  formataIdade,
  formatPrice,
  formataTelefone,
  ORIGEM_PAGAMENTO,
  TIPO_USUARIO,
  TIPO_PARCELA,
} from '../../utils/funcoes';

import {
  optionsVencimentoCartao,
  optionsTipoCartao,
} from '../../utils/options';
import Pagamento from '../../components/Pagamento';
import CartaoSaudeAddDependente from '../../components/CartaoSaude/CartaoSaudeAddDependente';
import CartaoSaudeResponsavel from '../../components/CartaoSaude/CartaoSaudeResponsavel';
import CartaoSaudeTitular from '../../components/CartaoSaude/CartaoSaudeTitular';
import CartaoSaudeCancelar from '../../components/CartaoSaude/CartaoSaudeCancelar';
import CartaoSaudeMotivoNaoRenovar from '../../components/CartaoSaude/CartaoSaudeMotivoNaoRenovar';
import CartaoSaudeContrato from '../../components/CartaoSaude/CartaoSaudeContrato';
import Cobranca from '../Relatorios/Cobranca/Cadastro';

import SelectSync from '../../components/SelectSync';
import getResponseErrors from '../../utils/getResponseErrors';
import ComentarioCadastro, {
  IComentario,
  origemComentario,
} from './ComentarioCadastro';
import Boleto, {
  IRetornoBoletoPaciente,
} from '../../components/Pagamento/Boleto';
import Manutencao from '../../components/CartaoSaude/Manutencao';
import PagamentoEmLote from './PagamentoEmLote';
import CartaoSaudeRemoveDependente from '../../components/CartaoSaude/CartaoSaudeRemoveDependente';

export interface IPaciente {
  PacCodigo: number;
  PacPessoaFisica: boolean;
  PacNome: string;
  PacNomeSocial: string;
  PacDataNasc: Date;
  PacDataNascFormatada: string;
  PacIdade: string;
  PacCelular: string;
  PacTelefone: string;
  PacCPF: string;
  PacCPFFormatado: string;
  PacRG: string;
  PacCNPJ: string;
  PacCNPJFormatado: string;
  PacContato: string;
  PacTelefonesFormatado: string;
  PacEmail: string;
}

export interface IDependente {
  DepCodigo: number;
  DepPacCodigo: number;
  DepPlaCodigo: number;
  DepParentesco: string;
  DepResponsavel: boolean;
  DepTitular: boolean;
  DepDataInicio: Date;
  DepDataExclusao?: Date;
  DepDataInicioFormatado: string;
  DepDataExclusaoFormatado: string;
  paciente: IPaciente;
}

export interface IParcelas {
  CprCodigo: number;
  CprCodOrigem: number;
  CprOrigem: number;
  CprCatCodigo: number;
  CprDataVenc: Date;
  CprValor: number;
  CprNParcela: number;
  CprPago: boolean;
  CprExcluida: boolean;
  CprHistorico: string;
  CprDataPag?: Date;
  CprValorPag: number;
  CprClinica: number;
  CprParcelaAtiva: boolean;
  CprDataVencFormatado: string;
  CprDataPagFormatado: string;
  CprValorFormatado: string;
  CprValorPagFormatado: string;
  CprPagoFormatado: string;
  CprAtrasada: boolean;
  CprChave?: string;
  atualizado?: boolean;
  codigoBarras?: string;
  linhaDigitavel?: string;
  qrcodebase64?: string;
  CprJuros: number;
  CprMulta: number;
  CprDesconto: number;
  ValorTotal: number;
  boleto?: IRetornoBoletoPaciente;
}

interface ICobranca {
  CobCodigo: number;
  CobObservacao: string;
  CobData: Date;
  CobDataFormatado: string;
  CobDataAviso: Date;
  CobDataAvisoFormatado: string;
  CobTipo: string;
  CobUsuNome: string;
}

export interface ICartaoSaude {
  PlaCodigo: number;
  PlaNumero: string;
  PlaValor: number;
  PlaDataInicio: Date;
  PlaDataFim: Date;
  PlaDiaVencimento: number;
  PlaStatus: boolean;
  PlaSituacao: 0 | 1 | 2 | 3 | 6;
  PlaClinica: number;
  PlaRenovado: boolean;
  PlaContratoAssinado: boolean;
  PlaTipo: number;
  PlaMeses: number;
  PlaNegociacao: boolean;
  PlaValorPorPessoa: number;
  PlaValorInclusao: number;
  ehEmpresarial: boolean;
  dependentes: IDependente[];
  comentarios: IComentario[];
  cobrancas: ICobranca[];
  parcelas: IParcelas[];
  motivoCancelamento: string;
  motivoNaoRenovar: string;
  PlaDataInicioFormatado: string;
  PlaDataFimFormatado: string;
  statusFormatado: string;
  color: string;
  PlaMotCodigo: number;
  PlaMotData: Date;
  PlaMotDataFormatado: string;
  PlaMotDescricao: string;
  PlaMotUsuCodigo: number;
  PlaCanCodigo: number;
  PlaCanData: Date;
  PlaCanDataFormatado: string;
  PlaCanDescricao: string;
  PlaCanUsuCodigo: number;
  podeRenovar: boolean;
  msgRenovar: string;
  podeCancelar: boolean;
  novo: boolean;
  geraContrato: {
    addDependente: boolean;
    removeDependente: boolean;
    alteraResponsavel: boolean;
    alteraTitular: boolean;
  };
  updated_at: Date;
  boletos: IRetornoBoletoPaciente[];
}

export interface IDadosPagamento {
  tituloPagamento: string;
  pagamentoSelecionado?: number;
  codOrigem?: number;
}

interface IRetornoBoleto {
  cprCodigo: number;
  link: string;
}

interface IUrlParams {
  id: string;
}

const situacaoCartao = {
  0: 'INATIVO - Cancelado',
  1: 'INATIVO - Cancelado',
  2: 'INATIVO - Expirado',
  3: 'INATIVO - Atrasado',
  6: 'Ativo',
  7: 'Não localizado',
};

const CartaoSaudeDetalhe: React.FC = () => {
  const { addToast } = useToast();
  const { user, clinica } = useAuth();
  const { imagensClinica } = useClinica();
  const { params } = useRouteMatch<IUrlParams>();
  const { id } = params;
  const [plaCodigo, setPlaCodigo] = useState<number | undefined>(
    id ? Number(id) : undefined,
  );
  const [ehAdmin, _] = useState(user.UsuTipo === TIPO_USUARIO.ADMINISTRADOR);
  const [ehGerente, setEhGerente] = useState(
    user.UsuTipo === TIPO_USUARIO.SUPERVISOR,
  );
  const [plano, setPlano] = useState<ICartaoSaude | undefined>();
  const [titular, SetTitular] = useState<IDependente>();
  const [responsavel, SetResponsavel] = useState<IDependente | undefined>();
  const [dependentesAtivos, SetDependentesAtivos] = useState<
    IDependente[] | undefined
  >();
  const [dependentesExcluidos, SetDependentesExcluidos] = useState<
    IDependente[] | undefined
  >();
  const [parcelasAtivas, SetParcelasAtivas] = useState<
    IParcelas[] | undefined
  >();
  const [parcelasInativas, SetParcelasInativas] = useState<
    IParcelas[] | undefined
  >();

  const [parcelasManutencao, SetParcelasManutencao] = useState<
    IParcelas[] | undefined
  >();

  const [parcelasLote, SetParcelasLote] = useState<IParcelas[] | undefined>();
  const [
    codigosParcelasAtrasadas,
    setCodigosParcelasAtrasadas,
  ] = useState<string>();
  const [comentarios, SetComentarios] = useState<IComentario[]>([]);
  const [cobrancas, SetCobrancas] = useState<ICobranca[] | undefined>();
  const [loading, setLoading] = useState(false);
  const [contratosAssinados, setContratosAssinados] = useState(true);
  const [showModalPagamento, setShowModalPagamento] = useState(false);
  const [showModalAddDependente, setShowModalAddDependente] = useState(false);
  const [showModalResponsavel, setShowModalResponsavel] = useState(false);
  const [showModalTitular, setShowModalTitular] = useState(false);
  const [showModalVencimento, setShowModalVencimento] = useState(false);
  const [showModalComentario, setShowModalComentario] = useState(false);
  const [showModalCancelaCartao, setShowModalCancelaCartao] = useState(false);
  const [showModalMotivonaorenovar, setShowModalMotivonaorenovar] = useState(
    false,
  );
  const [showModalManutencao, setShowModalManutencao] = useState(false);
  const [showModalContratos, setShowModalContratos] = useState(false);
  const [codigoDependenteExcluir, setCodigoDependenteExcluir] = useState<
    number | undefined
  >(undefined);
  const [showBotaoPagamento, setShowBotaoPagamento] = useState(true);
  const [showModalCobranca, setShowModalCobranca] = useState(false);
  const [showModalPagLote, setShowModalPagLote] = useState(false);
  const [dadosPagamento, setDadosPagamento] = useState<
    IDadosPagamento | undefined
  >();

  const optionVencimento = useMemo(() => {
    if (clinica.CliDiasVencimento && clinica.CliDiasVencimento !== '') {
      // dr saude
      const dias = clinica.CliDiasVencimento.split(',').map(dia => {
        return {
          value: dia.toString(),
          label: dia.toString(),
        };
      });
      return dias;
    }
    return optionsVencimentoCartao;
  }, [clinica.CliDiasVencimento]);

  const logoCartao =
    imagensClinica.find(img => img.nome === 'logoCartao')?.arquivo_url || '';

  const formRefVencimento = useRef<FormHandles>(null);

  const handleFormataDependentes = useCallback(
    (dependentes: IDependente[], ehEmpresarial: boolean) => {
      const dependentesFormatado = dependentes.map(dep => ({
        ...dep,
        DepDataInicioFormatado: format(
          parseISO(dep.DepDataInicio.toString()),
          'dd/MM/yyyy',
        ),
        DepDataExclusaoFormatado: dep.DepDataExclusao
          ? format(parseISO(dep.DepDataExclusao.toString()), 'dd/MM/yyyy')
          : '',
        paciente: {
          ...dep.paciente,
          PacCPFFormatado: formataCPF(dep.paciente.PacCPF),
          PacCNPJFormatado: formataCNPJ(dep.paciente.PacCNPJ),
          PacDataNascFormatada: dep.paciente.PacPessoaFisica
            ? format(
              parseISO(dep.paciente.PacDataNasc.toString()),
              'dd/MM/yyyy',
            )
            : '01/01/1990',
          PacIdade: dep.paciente.PacPessoaFisica
            ? formataIdade(parseISO(dep.paciente.PacDataNasc.toString()))
            : '0',
          PacTelefonesFormatado:
            dep.paciente.PacTelefone && dep.paciente.PacTelefone.length > 0
              ? `${formataTelefone(
                dep.paciente.PacCelular,
              )} - ${formataTelefone(dep.paciente.PacTelefone)}`
              : formataTelefone(dep.paciente.PacCelular),
        },
      }));

      SetTitular(
        ehEmpresarial === false
          ? dependentesFormatado.find(
            dep => dep.DepTitular && !dep.DepDataExclusao,
          )
          : dependentesFormatado.find(
            dep => dep.DepResponsavel && !dep.DepDataExclusao,
          ),
      );
      SetResponsavel(
        dependentesFormatado.find(
          dep => dep.DepResponsavel && !dep.DepDataExclusao,
        ),
      );
      SetDependentesAtivos(
        dependentesFormatado.filter(
          dep => !dep.DepResponsavel && !dep.DepTitular && !dep.DepDataExclusao,
        ),
      );
      SetDependentesExcluidos(
        dependentesFormatado.filter(dep => dep.DepDataExclusao),
      );
    },
    [],
  );

  const handleFormataDadosCartao = useCallback(
    (dados: ICartaoSaude) => {
      const parcela1 = dados.parcelas.find(
        pac =>
          pac.CprPago &&
          pac.CprParcelaAtiva &&
          !pac.CprExcluida &&
          pac.CprNParcela === 1,
      );

      const dataParcela1 = parcela1
        ? addDays(parseISO(parcela1.CprDataVenc.toString()), -1)
        : new Date();

      const parcelasPagas = dados.parcelas.filter(
        pac =>
          pac.CprPago &&
          pac.CprParcelaAtiva &&
          !pac.CprExcluida &&
          pac.CprNParcela < TIPO_PARCELA.INCLUSAO_DEPENDENTE &&
          isAfter(parseISO(pac.CprDataVenc.toString()), dataParcela1),
      ).length;

      const penultimaParcela = dados.PlaMeses - 1;

      setShowBotaoPagamento(
        parcelasPagas !== penultimaParcela ||
        (parcelasPagas === penultimaParcela && dados.PlaMotCodigo > 0) ||
        !dados.podeRenovar,
      );

      const codigoAtrasadas: number[] = [];

      const parcelasFormatadas = dados.parcelas.map(parc => {
        const atrasada =
          parc.CprPago === false &&
          isBefore(parseISO(parc.CprDataVenc.toString()), endOfToday());

        if (atrasada) codigoAtrasadas.push(parc.CprCodigo);

        const dataPagFormatada = parc.CprDataPag
          ? format(parseISO(parc.CprDataPag.toString()), 'dd/MM/yyyy')
          : '';

        const CprDataVenc = parseISO(parc.CprDataVenc.toString());

        return {
          ...parc,
          CprDataVenc,
          CprDataVencFormatado: format(CprDataVenc, 'dd/MM/yyyy'),
          CprDataPagFormatado: !atrasada ? dataPagFormatada : 'Atrasada',
          CprValorFormatado: formatPrice(parc.CprValor),
          CprValorPagFormatado: formatPrice(parc.CprValorPag),
          CprPagoFormatado: parc.CprPago === true ? 'Sim' : 'Não',
          CprAtrasada: atrasada,
          boleto: dados.boletos
            ? dados.boletos.find(bol => bol.CprCodigo === parc.CprCodigo)
            : undefined,
        };
      });

      if (codigoAtrasadas.length > 0)
        setCodigosParcelasAtrasadas(codigoAtrasadas.join(','));

      const tipoCartaotexto =
        optionsTipoCartao.find(opt => opt.value === dados.PlaTipo.toString())
          ?.label || 'NORMAL';
      const ehEmpresarial = tipoCartaotexto.includes('EMPRESA');

      const planoFormatado = {
        ...dados,
        parcelas: parcelasFormatadas,
        ehEmpresarial,
        PlaDataInicio: parseISO(dados.PlaDataInicio.toString()),
        PlaDataInicioFormatado: format(
          parseISO(dados.PlaDataInicio.toString()),
          'dd/MM/yyyy',
        ),
        PlaDataFimFormatado: format(
          parseISO(dados.PlaDataFim.toString()),
          'dd/MM/yyyy',
        ),
        statusFormatado: situacaoCartao[dados.PlaSituacao || 7],
        // statusFormatado: handleStatusCartao(dados.PlaSituacao),
        // PlaRenovado: dados.PlaRenovado
        PlaCanDataFormatado: dados.PlaCanData
          ? format(parseISO(dados.PlaCanData.toString()), 'dd/MM/yyyy')
          : '',
        PlaMotDataFormatado: dados.PlaMotData
          ? format(parseISO(dados.PlaMotData.toString()), 'dd/MM/yyyy')
          : '',
      };

      setPlano(planoFormatado);

      setContratosAssinados(planoFormatado.PlaContratoAssinado);

      handleFormataDependentes(
        planoFormatado.dependentes,
        planoFormatado.ehEmpresarial,
      );

      SetParcelasAtivas(
        parcelasFormatadas.filter(
          parc => parc.CprParcelaAtiva && !parc.CprExcluida,
        ),
      );

      SetParcelasInativas(
        parcelasFormatadas.filter(
          parc => !parc.CprParcelaAtiva && !parc.CprExcluida,
        ),
      );

      SetParcelasManutencao(
        parcelasFormatadas
          .map(par => {
            return {
              ...par,
              CprHistorico: par.CprHistorico.replace('CARTÃO SAÚDE ', ''),
            };
          })
          .sort((a, b) => Number(a.CprCodigo) - Number(b.CprCodigo)),
      );

      SetParcelasLote(
        parcelasFormatadas
          .filter(parc => parc.CprPago === false && parc.CprParcelaAtiva && !parc.CprExcluida)
          .map(par => {
            return {
              ...par,
              CprHistorico: par.CprHistorico.replace('CARTÃO SAÚDE ', ''),
            };
          })
          .sort((a, b) => Number(a.CprCodigo) - Number(b.CprCodigo)),
      );

      SetComentarios(
        dados.comentarios.map(com => ({
          ...com,
          ComDataFormatado: format(
            parseISO(com.ComData.toString()),
            'dd/MM/yyyy',
          ),
          ComDataAvisoFormatado: com.ComDataAviso
            ? format(parseISO(com.ComDataAviso.toString()), 'dd/MM/yyyy')
            : '',
          ComOrigemTexto: origemComentario[com.ComOrigem || 0],
        })),
      );

      SetCobrancas(
        dados.cobrancas.map(cob => ({
          ...cob,
          CobDataFormatado: format(
            parseISO(cob.CobData.toString()),
            'dd/MM/yyyy',
          ),
          CobDataAvisoFormatado: cob.CobDataAviso
            ? format(parseISO(cob.CobDataAviso.toString()), 'dd/MM/yyyy')
            : '',
        })),
      );
    },
    [handleFormataDependentes],
  );

  const loadDados = useCallback(
    async (codigoPlano: number): Promise<void> => {
      setLoading(true);
      try {
        const response = await api.get<ICartaoSaude>(`/planos/${codigoPlano}`);

        handleFormataDadosCartao(response.data);
      } catch (error) {
        console.log(error);
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar cartão',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [handleFormataDadosCartao, addToast],
  );

  useEffect(() => {
    if (plaCodigo && plaCodigo > 0) loadDados(plaCodigo);
  }, [plaCodigo, loadDados]);

  useEffect(() => {
    document.title = plano?.PlaNumero ? `Cartão #${plano.PlaNumero}` : 'Cartão';
  }, [plano?.PlaNumero]);

  const handlePagamento = useCallback(
    (titulo: string, cprCodigo?: number, cprCodOrigem?: number) => {
      setDadosPagamento({
        tituloPagamento: titulo,
        pagamentoSelecionado: cprCodigo,
        codOrigem: cprCodOrigem,
      });

      setShowModalPagamento(true);
    },
    [],
  );

  const handleFecharModalPagamento = useCallback(
    async (load: boolean) => {
      setShowModalPagamento(false);
      if (load) {
        await loadDados(Number(id));

        setDadosPagamento(undefined);
      }
    },
    [id, loadDados],
  );

    const handleFecharModalDependente = useCallback(
    async (load: boolean) => {
      setCodigoDependenteExcluir(undefined)
      if (load)
        await loadDados(Number(id));
    },
    [id, loadDados],
  );


  const handleAlteraDiaVencimento = useCallback(
    async (dados: { vencimento: string }) => {
      setLoading(true);
      const { vencimento } = dados;
      try {
        if (!vencimento || vencimento.length === 0) {
          formRefVencimento.current?.setFieldError(
            'vencimento',
            'Selecione um dia',
          );
          return;
        }
        if (Number(vencimento) === plano?.PlaDiaVencimento) {
          addToast({
            title: 'Escolha um vencimento diferente do atual',
            type: 'error',
          });
          return;
        }

        const response = await api.put<ICartaoSaude>(
          `planos/alteravencimento/${plaCodigo}`,
          {
            NovoDiaVencimento: vencimento,
            updated_at: plano?.updated_at,
          },
        );
        setShowModalVencimento(false);
        handleFormataDadosCartao(response.data);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível atualizar o titular',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      plaCodigo,
      addToast,
      plano?.PlaDiaVencimento,
      plano?.updated_at,
      handleFormataDadosCartao,
    ],
  );

  const handleRenovarPlano = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.put<ICartaoSaude>(
        `planos/renovar/${plaCodigo}`,
        { updated_at: plano?.updated_at },
      );
      // setShowModalVencimento(false);
      handleFormataDadosCartao(response.data);
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível renovar o cartão',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [plaCodigo, plano?.updated_at, addToast, handleFormataDadosCartao]);

  const exibeBotaoRemoverExpirado = useMemo(() => {
    return (
      (ehAdmin || (ehGerente && !clinica.CliDrSaude)) &&
      plano?.PlaSituacao === 2
    );
  }, [plano?.PlaSituacao, ehAdmin, ehGerente, clinica.CliDrSaude]);



  const handleGeraBoletos = useCallback(async () => {
    setLoading(true);
    try {
      if (plaCodigo) {
        const retornoBoletos = await api.patch<IRetornoBoleto[]>(
          `/caixa/gerarboletos/${plaCodigo}`,
        );

        if (retornoBoletos.data.length > 0) {

          window.location.reload();
        }
     }
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível gerar boletos',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [plaCodigo, addToast]);

  const exibeBotoesEdicao = useMemo(() => {
    return (
      (plano?.PlaStatus ||
        plano?.novo ||
        ehAdmin ||
        (ehGerente && !clinica.CliDrSaude)) &&
      user.UsuTipo !== TIPO_USUARIO.COBRANCA &&
      (plano?.PlaSituacao === 3 || plano?.PlaSituacao === 6)
    );
  }, [
    plano?.PlaStatus,
    plano?.PlaSituacao,
    plano?.novo,
    ehAdmin,
    ehGerente,
    clinica.CliDrSaude,
    user.UsuTipo,
  ]);

  const handleRetornoComentario = useCallback((comentario: IComentario) => {
    SetComentarios(state => [...state, comentario]);
    setShowModalComentario(false);
  }, []);

  const handlesShowModalManutencao = useCallback(() => {
    // SetComentarios(state => [...state, comentario]);
    setShowModalManutencao(true);
  }, []);

  const handleAssinouContrato = useCallback((contratoAssinado: boolean) => {
    setContratosAssinados(contratoAssinado);
  }, []);

  return (
    <Container fluid className="mt-2">
      {loading && <Loading />}

      {showModalAddDependente && plano && (
        <Modal
          show={showModalAddDependente}
          titulo="Adicionar Dependente"
          handleFecharModal={() => setShowModalAddDependente(false)}
        >
          <CartaoSaudeAddDependente
            PlaCodigo={plano.PlaCodigo}
            updated_at={plano.updated_at}
            handleFecharComponent={dados => {
              setShowModalAddDependente(false);
              handleFormataDadosCartao(dados);
            }}
          />
        </Modal>
      )}
      {showModalResponsavel && plano && (
        <Modal
          show={showModalResponsavel}
          titulo="Responsável"
          handleFecharModal={() => setShowModalResponsavel(false)}
        >
          <CartaoSaudeResponsavel
            PlaCodigo={plano.PlaCodigo}
            updated_at={plano.updated_at}
            responsavel={responsavel}
            geraNovoContrato={plano.geraContrato.alteraResponsavel}
            handleSalvouResponsavel={dependentes => {
              handleFormataDependentes(dependentes, plano.ehEmpresarial);
              setShowModalResponsavel(false);
            }}
            handleRemoveuResponsavel={() => {
              SetResponsavel(undefined);
              setShowModalResponsavel(false);
            }}
          />
        </Modal>
      )}
      {showModalTitular && plano && (
        <Modal
          show={showModalTitular}
          titulo="Alteração de titular"
          handleFecharModal={() => setShowModalTitular(false)}
        >
          <CartaoSaudeTitular
            PlaCodigo={plano.PlaCodigo}
            updated_at={plano.updated_at}
            dependentes={dependentesAtivos}
            geraNovoContrato={plano.geraContrato.alteraTitular}
            handleSalvouTitular={dependentes => {
              handleFormataDependentes(dependentes, plano.ehEmpresarial);
              setShowModalTitular(false);
            }}
          />
        </Modal>
      )}
      {showModalVencimento && plano && (
        <Modal
          show={showModalVencimento}
          titulo="Alterar dia de vencimento"
          handleFecharModal={() => setShowModalVencimento(false)}
        >
          <Form
            ref={formRefVencimento}
            className="mt-2 pb-5"
            onSubmit={handleAlteraDiaVencimento}
          >
            <SelectSync
              label="Novo dia de vencimento"
              name="vencimento"
              options={optionVencimento}
              handleSelectChange={() => console.log('')}
            />
            <Button
              type="submit"
              className="mt-2"
              variant="success"
              disabled={loading}
            >
              Alterar Dia de Vencimento
            </Button>
          </Form>
        </Modal>
      )}
      {showModalComentario && plano && (
        <Modal
          show={showModalComentario}
          titulo="Novo Comentário"
          handleFecharModal={() => setShowModalComentario(false)}
        >
          <ComentarioCadastro
            handleRetorno={handleRetornoComentario}
            plaCodigo={plano.PlaCodigo}
          />
        </Modal>
      )}

      {showModalCancelaCartao && plano && parcelasAtivas && (
        <Modal
          show={showModalCancelaCartao}
          titulo="Cancelar cartão"
          handleFecharModal={() => setShowModalCancelaCartao(false)}
        >
          <CartaoSaudeCancelar
            PlaCodigo={plano.PlaCodigo}
            updated_at={plano.updated_at}
            handleCancelouCartao={planoCancelado => {
              handleFormataDadosCartao(planoCancelado);
              setShowModalCancelaCartao(false);
            }}
            handleFechar={() => setShowModalCancelaCartao(false)}
          />
        </Modal>
      )}
      {showModalMotivonaorenovar && plano && (
        <Modal
          show={showModalMotivonaorenovar}
          titulo="Motivo não renovar"
          handleFecharModal={() => setShowModalMotivonaorenovar(false)}
        >
          <CartaoSaudeMotivoNaoRenovar
            PlaCodigo={plano.PlaCodigo}
            updated_at={plano.updated_at}
            handleSalvouMotivo={planoAtualizado => {
              handleFormataDadosCartao(planoAtualizado);
              setShowModalMotivonaorenovar(false);
            }}
            handleFechar={() => setShowModalMotivonaorenovar(false)}
          />
        </Modal>
      )}
      {showModalPagamento && (
        <Modal
          show={showModalPagamento}
          titulo={dadosPagamento?.tituloPagamento || ''}
          handleFecharModal={() => setShowModalPagamento(false)}
        >
          <Pagamento
            handleFechar={handleFecharModalPagamento}
            tipo={ORIGEM_PAGAMENTO.CARTAO.toString()}
            cprCodigo={dadosPagamento?.pagamentoSelecionado}
          />
        </Modal>
      )}
      {showModalCobranca && plano && codigosParcelasAtrasadas && (
        <Modal
          show={showModalCobranca}
          titulo="Registro de Cobrança"
          handleFecharModal={() => setShowModalCobranca(false)}
        >
          <Cobranca
            dadosCobranca={{
              plaCodigo: plano?.PlaCodigo,
              codigo: codigosParcelasAtrasadas,
            }}
            handleFechar={() => setShowModalCobranca(false)}
          />
        </Modal>
      )}

      {codigoDependenteExcluir && plano && (
        <Modal
          show={!!codigoDependenteExcluir}
          titulo="Remover Dependente"
          handleFecharModal={() => setCodigoDependenteExcluir(undefined)}
        >
          <CartaoSaudeRemoveDependente
            PlaCodigo={plano.PlaCodigo}
            DepCodigo={codigoDependenteExcluir}
            updated_at={plano.updated_at}
            rotaExpirado={exibeBotaoRemoverExpirado}
            handleFecharComponent={loadCartao => {
              setCodigoDependenteExcluir(undefined);
              handleFecharModalDependente(loadCartao);
            }}
          />

        </Modal>
      )}

      {showModalContratos && plano && (
        <Modal
          show={showModalContratos}
          titulo="Contratos do Cartão"
          handleFecharModal={() => setShowModalContratos(false)}
        >
          <CartaoSaudeContrato
            PlaCodigo={plano.PlaCodigo}
            handleAssinouContrato={handleAssinouContrato}
            handleFecharModal={() => setShowModalContratos(false)}
          />
        </Modal>
      )}

      {showModalManutencao && parcelasManutencao && (
        <Modal
          show={showModalManutencao}
          titulo="Manutenção de parcelas"
          handleFecharModal={() => {
            setShowModalManutencao(false);
            window.location.reload();
          }}
          large
        >
          <Manutencao parcelas={parcelasManutencao} />
        </Modal>
      )}

      {showModalPagLote && parcelasLote && (
        <Modal
          show={showModalPagLote}
          titulo="Manutenção de parcelas"
          handleFecharModal={() => {
            setShowModalPagLote(false);
            window.location.reload();
          }}
          large
        >
          <PagamentoEmLote
            parcelas={parcelasLote}
            handleFechar={() => {
              setShowModalPagLote(false);
              window.location.reload();
            }}
          />
        </Modal>
      )}

      {plano && titular && (
        <>
          <Cartao ativo={plano.novo === true ? true : plano.PlaStatus}>
            <div>
              <img src={logoCartao} alt="Cartão Saúde" />
              <div>
                {plano.ehEmpresarial === false ? (
                  <>
                    <h6>
                      {titular.paciente.PacNomeSocial.trim() !== '' ? (
                        <span>
                          Nome Social: <b>{titular.paciente.PacNomeSocial}</b>
                        </span>
                      ) : (
                        <b>{titular.paciente.PacNome}</b>
                      )}

                      {exibeBotoesEdicao && (
                        <ButtonAdd
                          type="button"
                          onClick={() => setShowModalTitular(true)}
                        >
                          <FaEdit size={15} />
                        </ButtonAdd>
                      )}
                    </h6>

                    <p>
                      <FaCalendar size={13} />{' '}
                      {titular.paciente.PacDataNascFormatada} -{' '}
                      {titular.paciente.PacIdade}
                    </p>
                    <p>
                      <FaPhone size={13} />{' '}
                      {titular.paciente.PacTelefonesFormatado}
                    </p>
                  </>
                ) : (
                  <>
                    <h6>
                      <b>{titular.paciente.PacNome} - PLANO EMPRESA</b>
                    </h6>

                    <p>{`CNPJ ${titular.paciente.PacCNPJFormatado}`}</p>
                    <p>
                      <FaPhone size={13} />{' '}
                      {titular.paciente.PacTelefonesFormatado}{' '}
                      {`Contato: ${titular.paciente.PacContato}`}
                    </p>
                  </>
                )}
                {plano.PlaNegociacao && (
                  <>
                    <b>Negociação - </b> Valor por pessoa:{' '}
                    {formatPrice(plano.PlaValorPorPessoa)}, Valor inclusão:{' '}
                    {formatPrice(plano.PlaValorInclusao)}
                  </>
                )}
              </div>
            </div>
            <div style={{ height: '30px', fontSize: '26px' }}>
              {!contratosAssinados && (
                <Badge pill variant="warning">
                  Assinar Contrato
                </Badge>
              )}
            </div>
            <div>
              {plano.PlaStatus ? (
                <FaRegCheckCircle size={50} />
              ) : (
                <FaBan size={50} />
              )}{' '}
              {plano.novo === true ? 'NOVO' : plano.statusFormatado}
            </div>
          </Cartao>

          <Row noGutters className="mb-2">
            <Col sm={12} md={6} lg={2}>
              <Card style={{ height: '100%' }}>
                <h2>
                  <b>CARTÃO</b>
                </h2>
                <CardBody style={{ textAlign: 'center', padding: '10px 5px' }}>
                  <h4>{plano.PlaNumero}</h4>
                  <p>
                    {plano.PlaRenovado && (
                      <b className="text-primary">Renovado</b>
                    )}{' '}
                    ADESÃO {plano.PlaDataInicioFormatado}
                    <br />
                    VALIDADE {plano.PlaDataFimFormatado}
                  </p>
                </CardBody>
              </Card>
            </Col>
            <Col sm={12} md={6} lg={2} className="pl-md-1 mt-2 mt-md-0">
              <Card style={{ height: '100%' }}>
                <CardHeaderCenter>
                  <b>VENCIMENTO</b>
                  {exibeBotoesEdicao && (
                    <ButtonAdd
                      type="button"
                      onClick={() => setShowModalVencimento(true)}
                    >
                      <FaEdit size={15} />
                    </ButtonAdd>
                  )}
                </CardHeaderCenter>

                <CardBody style={{ textAlign: 'center', padding: '10px 5px' }}>
                  <h4>{plano.PlaDiaVencimento}</h4>
                  <p>
                    PRÓXIMA PARCELA
                    <br />
                    {parcelasAtivas &&
                      parcelasAtivas.find(par => par.CprPago === false)
                        ?.CprDataVencFormatado}
                  </p>
                </CardBody>
              </Card>
            </Col>
            <Col sm={12} md={6} lg={3} className="pl-md-1 mt-2 mt-md-0">
              <Card style={{ height: '100%' }}>
                <CardHeaderCenter>
                  <b>RESPONSÁVEL</b>
                  {exibeBotoesEdicao && plano.ehEmpresarial === false && (
                    <ButtonAdd
                      type="button"
                      onClick={() => setShowModalResponsavel(true)}
                    >
                      <FaEdit size={15} />
                    </ButtonAdd>
                  )}
                </CardHeaderCenter>

                <CardBody style={{ textAlign: 'center', padding: '10px 5px' }}>
                  {responsavel ? (
                    <>
                      <h6>{responsavel.paciente.PacNome}</h6>
                      <p style={{ fontSize: '.8rem' }}>
                        {responsavel.paciente.PacPessoaFisica
                          ? `CPF ${responsavel.paciente.PacCPFFormatado}`
                          : `CNPJ ${responsavel.paciente.PacCNPJFormatado}`}
                        <br />
                        TELEFONE {responsavel.paciente.PacTelefonesFormatado}
                      </p>
                    </>
                  ) : (
                    <>
                      <h6>
                        {titular?.paciente.PacNomeSocial.trim() !== '' ? (
                          <>
                            <span className="small">Nome Social: </span>
                            <b>{titular?.paciente.PacNomeSocial}</b>
                          </>
                        ) : (
                          <b>{titular?.paciente.PacNome}</b>
                        )}
                      </h6>
                      <p style={{ fontSize: '.8rem' }}>
                        CPF {titular?.paciente.PacCPFFormatado}
                        <br />
                        TELEFONE {titular?.paciente.PacTelefonesFormatado}
                      </p>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
            <Col sm={12} md={6} lg={3} className="pl-md-1 mt-2 mt-md-0">
              <Card style={{ height: '100%' }}>
                <h2>
                  <b>IMPRESSÕES</b>
                </h2>
                <CardBody style={{ justifyContent: 'center' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-around',
                    }}
                  >
                    <Link
                      style={{ textAlign: 'center' }}
                      to={`/cartaosaudeimpressao/${plaCodigo}/carne`}
                      target="_blank"
                    >
                      <FaFile size={26} />
                      <br />
                      CARNE
                    </Link>
                    <Button
                      className="border-0"
                      size="sm"
                      variant="outline-primary"
                      onClick={() => setShowModalContratos(true)}
                    >
                      <FaGavel size={26} />
                      <br />
                      CONTRATO
                    </Button>
                    <Link
                      style={{ textAlign: 'center' }}
                      to={`/cartaosaudeimpressao/${plaCodigo}/etiqueta`}
                      target="_blank"
                    >
                      <FaAddressCard size={26} />
                      <br />
                      ETIQUETA
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col sm={12} md={6} lg={2} className="pl-md-1 mt-2 mt-md-0">
              <Card style={{ height: '100%' }}>
                <h2>
                  <b>AÇÕES</b>
                </h2>
                <CardBody style={{ justifyContent: 'center' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-around',
                    }}
                  >
                    {!showBotaoPagamento && (
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={() => setShowModalMotivonaorenovar(true)}
                      >
                        Liberar {plano.PlaMeses}º
                      </Button>
                    )}
                    {plano.podeRenovar && (
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={handleRenovarPlano}
                      >
                        Renovar
                      </Button>
                    )}
                    {plano.podeCancelar && (
                      <Button
                        type="button"
                        size="sm"
                        variant="danger"
                        onClick={() => setShowModalCancelaCartao(true)}
                        disabled={user.UsuTipo > clinica.CliPerfilCancelaCartao}
                      >
                        Cancelar
                      </Button>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {!showBotaoPagamento && (
            <div className="alert alert-primary p-3 mt-2">
              <h3>
                <b>Lembrete de Renovação</b>
              </h3>
              <p>
                O cartão chegou na sua {plano.PlaMeses - 1}º parcela, para
                realizar o pagamento da {plano.PlaMeses}º parcela é necessário
                que o cartão seja <b>Renovado</b> ou que seja inserido um{' '}
                <b>Motivo de não Renovação</b>.
              </p>
            </div>
          )}

          {plano && plano.motivoCancelamento && (
            <div className="alert alert-danger p-3 mt-2">
              Cliente relatou em <b>{plano.PlaCanDataFormatado}</b> que deseja
              cancelar o cartão pelo motivo: <b>{plano.motivoCancelamento}</b> -{' '}
              {plano.PlaCanDescricao}.
            </div>
          )}

          {plano && plano.msgRenovar && plano.msgRenovar.length > 0 && (
            <div className="alert alert-warning p-3 mt-2">
              {plano.msgRenovar}
            </div>
          )}

          {plano && plano.motivoNaoRenovar && (
            <div className="alert alert-info p-3 mt-2">
              Cliente relatou em <b>{plano.PlaMotDataFormatado}</b> que não
              deseja renovar o cartão pelo motivo:{' '}
              <b>{plano.motivoNaoRenovar}</b> - {plano.PlaMotDescricao}.
            </div>
          )}

          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <span>
                    <FaUser size={15} /> <b>DEPENDENTES</b>
                  </span>
                  <span>
                    <b>Qtd: {dependentesAtivos?.length || '0'}</b>
                  </span>
                  {exibeBotoesEdicao && (
                    <ButtonAdd
                      type="button"
                      onClick={() => setShowModalAddDependente(true)}
                    >
                      <FaPlusCircle size={15} />
                    </ButtonAdd>
                  )}
                </CardHeader>

                <CardBody style={{ height: '241px' }}>
                  <Table className="text-secondary" hover size="sm">
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Nome</th>
                        <th>Parentesco</th>
                        <th>Data Adesão</th>
                        <th>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dependentesAtivos?.map(dep => (
                        <tr key={`dep-${dep.DepCodigo}`}>
                          <td>
                            {dep.paciente.PacNomeSocial !== ''
                              ? `Nome Social: ${dep.paciente.PacNomeSocial}`
                              : dep.paciente.PacNome}
                          </td>
                          <td>{dep.DepParentesco}</td>
                          <td>{dep.DepDataInicioFormatado}</td>
                          <td>
                            {(exibeBotoesEdicao ||
                              exibeBotaoRemoverExpirado) && (
                                <Button
                                  data-id={dep.DepCodigo}
                                  type="button"
                                  variant="outline-danger"
                                  size="sm"
                                  style={{ padding: '1px 8px' }}
                                  // eslint-disable-next-line prettier/prettier
                                  onClick={
                                    () =>
                                      setCodigoDependenteExcluir(dep.DepCodigo)
                                    // eslint-disable-next-line react/jsx-curly-newline
                                  }
                                >
                                  <FaTrash size={14} />
                                </Button>
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
              <br />
              <Card>
                <CardHeader>
                  <span>
                    <FaUser size={15} /> <b>HISTÓRICO DE DEPENDENTES</b>
                  </span>
                </CardHeader>

                <CardBody style={{ height: '241px' }}>
                  <Table className="text-secondary" hover size="sm">
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Nome</th>
                        <th>Parentesco</th>
                        <th>Data Adesão</th>
                        <th>Data Exclusão</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dependentesExcluidos?.map(dep => (
                        <tr key={`depEx-${dep.DepCodigo}`}>
                          <td>
                            {dep.paciente.PacNomeSocial !== ''
                              ? `Nome Social: ${dep.paciente.PacNomeSocial}`
                              : dep.paciente.PacNome}
                          </td>
                          <td>{dep.DepParentesco}</td>
                          <td>{dep.DepDataInicioFormatado}</td>
                          <td>{dep.DepDataExclusaoFormatado}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
            <Col>
              <Card style={{ height: '578px' }}>
                <CardHeader>
                  <span>
                    <FaUser size={15} /> <b>PARCELAS</b>
                  </span>
                  {user.UsuCodigo === 1 && plaCodigo && (
                    <Button
                      data-id={plaCodigo}
                      type="button"
                      size="sm"
                      style={{ padding: '1px 8px' }}
                      className="bg-primary"
                      onClick={() => handlesShowModalManutencao()}
                    >
                      Manutenção
                    </Button>
                  )}

                  <Button
                    data-id={plaCodigo}
                    type="button"
                    size="sm"
                    style={{ padding: '1px 8px' }}
                    className="bg-primary"
                    onClick={() => setShowModalPagLote(true)}
                  >
                    Pagamento em lote
                  </Button>

                  {clinica.ConfigBoleto?.Emite &&
                    user.UsuTipo !== TIPO_USUARIO.COBRANCA && (
                      <ButtonAdd
                        type="button"
                        onClick={() => handleGeraBoletos()}
                        title="gerar Boletos"
                      >
                        <FaBarcode size={15} /> Gerar Boletos
                      </ButtonAdd>
                    )}
                </CardHeader>

                <CardBody>
                  <Table
                    className="text-secondary"
                    style={{ marginBottom: '9px' }}
                    hover
                    size="sm"
                  >
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Histórico</th>
                        <th>Data</th>
                        <th>Pago</th>
                        <th>Data pag.</th>
                        <th>Valor</th>
                        <th>Valor Pago</th>
                        <th>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {parcelasAtivas?.map(parc => (
                        <tr
                          key={`parc-${parc.CprCodigo}`}
                          data-id={parc.CprCodigo}
                          className={parc.CprAtrasada ? 'text-danger' : ''}
                        >
                          <td>{parc.CprHistorico}</td>
                          <td>{parc.CprDataVencFormatado}</td>
                          <td>{parc.CprPagoFormatado}</td>
                          <td>{parc.CprDataPagFormatado}</td>
                          <td>{parc.CprValorFormatado}</td>
                          <td>{parc.CprValorPagFormatado}</td>
                          <td>
                            <div style={{ display: 'flex' }}>
                              <Button
                                data-id={parc.CprCodigo}
                                type="button"
                                size="sm"
                                style={{ padding: '1px 8px' }}
                                disabled={
                                  !showBotaoPagamento ||
                                  user.UsuTipo === TIPO_USUARIO.COBRANCA
                                }
                                className={
                                  parc.CprPago ? 'bg-success' : 'bg-secondary'
                                }
                                // eslint-disable-next-line prettier/prettier
                                onClick={
                                  () =>
                                    handlePagamento(
                                      `Pagar Parcela - ${parc.CprHistorico}`,
                                      parc.CprCodigo,
                                      parc.CprCodOrigem,
                                    )
                                  // eslint-disable-next-line react/jsx-curly-newline
                                }
                              >
                                <FaCheckCircle size={14} />
                              </Button>
                              {clinica.ConfigBoleto?.Emite === true &&
                                user.UsuTipo !== TIPO_USUARIO.COBRANCA &&
                                !parc.CprPago && (
                                  <>
                                    <Boleto
                                      cprCodigo={parc.CprCodigo}
                                      contaPR={{
                                        ...parc,
                                        CprFormaPag: 0,
                                        CprReceita: 0,
                                        CprUsuCodigo: 0,
                                      }}
                                      atualizado={parc.atualizado === true}
                                      dadosBoleto={parc.boleto}
                                    />
                                  </>
                                )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card style={{ marginLeft: '0' }}>
                <CardHeader className="bg-danger">
                  <b>NEGOCIAÇÃO DE PARCELAS ATRASADAS</b>
                  {codigosParcelasAtrasadas && (
                    <ButtonAdd
                      type="button"
                      onClick={() => setShowModalCobranca(true)}
                    >
                      <FaPlusCircle size={15} />
                    </ButtonAdd>
                  )}
                </CardHeader>

                <CardBody style={{ height: '232px' }}>
                  <Table className="text-secondary" hover size="sm">
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Contato em</th>
                        <th>Colaborador</th>
                        <th>Resposta do Cliente</th>
                        <th>Novo Contato</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cobrancas?.map(cob => (
                        <tr key={`Cob-${cob.CobCodigo}`}>
                          <td>{cob.CobDataFormatado}</td>
                          <td>{cob.CobUsuNome}</td>
                          <td>{cob.CobObservacao}</td>
                          <td>{cob.CobDataAvisoFormatado}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
            <Col>
              <Card>
                <CardHeader>
                  <span>
                    <FaHistory size={15} /> <b>PAGAMENTOS REALIZADOS</b>
                  </span>
                </CardHeader>

                <CardBody
                  style={{ height: clinica.CliDrSaude ? '232px' : '509px' }}
                >
                  <Table className="text-secondary" hover size="sm">
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Histórico</th>
                        <th>Data</th>
                        <th>Data pag.</th>
                        <th>Valor Pago</th>
                        <th>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {parcelasInativas?.map(parc => (
                        <tr key={`parc-pago-${parc.CprCodigo}`}>
                          <td>{parc.CprHistorico}</td>
                          <td>{parc.CprDataVencFormatado}</td>
                          <td>{parc.CprDataPagFormatado}</td>
                          <td>{parc.CprValorPagFormatado}</td>
                          <td>
                            <Button
                              type="button"
                              size="sm"
                              className={
                                parc.CprPago ? 'bg-success' : 'bg-secondary'
                              }
                              // eslint-disable-next-line prettier/prettier
                              onClick={
                                () =>
                                  handlePagamento(
                                    `Parcela - ${parc.CprHistorico}`,
                                    parc.CprCodigo,
                                    parc.CprCodOrigem,
                                  )
                                // eslint-disable-next-line react/jsx-curly-newline
                              }
                            >
                              <FaCheckCircle size={14} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <span>
                    <FaHistory size={15} /> <b>HISTÓRICO</b>
                  </span>
                  <ButtonAdd
                    type="button"
                    onClick={() => setShowModalComentario(true)}
                  >
                    <FaPlusCircle size={15} />
                  </ButtonAdd>
                </CardHeader>

                <CardBody style={{ height: '232px' }}>
                  <Table className="text-secondary" hover size="sm">
                    <thead>
                      <tr className="bg-light text-dark">
                        <th>Tipo</th>
                        <th>Colaborador</th>
                        <th>Comentário</th>
                        <th>Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      {comentarios?.map(com => (
                        <tr key={`Cob-${com.ComCodigo}`}>
                          <td>{com.ComOrigemTexto}</td>
                          <td>{com.ComUsuNome}</td>
                          <td>{com.ComComentario}</td>
                          <td>{com.ComDataFormatado}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default CartaoSaudeDetalhe;
